<template>
  <div class="foot">
    <span v-if="params[type].text">{{params[type].text}}</span>
    <img class="cursor-help" v-if="type === 'Scan the QR code to sign in'" src="../../assets/images/scan_help_icon.png" @click="help">
    <a @click="clickRouter">{{params[type].router}}</a>
  </div>
</template>

<script>
  import uploadWebEvent from '../common/UploadWebEvent.js'
  import translate from '../common/Translate'
  import AppInfo from '../../appInfo/index'
  export default {
    data () {
      return {
        params: {
          // 已经有账号，登录
          'Already using crait': {
            text: 'Already using crait?',
            router: 'sign in',
            fn: function () {
              uploadWebEvent('SINGUP_TO_SIGNIN') // 埋点统计：注册页面主动跳转到登录页面
              return '/login/signin'
            }
          },
          // 没有账号，注册
          'No using crait': {
            text: "Don't have account?",
            router: 'sign up',
            fn: function () {
              uploadWebEvent('SINGIN_TO_SIGNUP') // 埋点统计：登录页面主动跳转到注册页面
              return '/login/signup'
            }
          },
          // 扫码登录
          'Scan the QR code to sign in': {
            text: translate('Scan the QR code to sign in')
          },
          // 忘记密码
          'Forgot password': {
            router: translate('Forgot password'),
            fn: function () {
              // 埋点统计：登录页面点击重置密码
              if (!AppInfo.isGenericVersion()) {
                uploadWebEvent('SIGNIN_TO_RESET', {
                  type: this.isEmail ? 0 : 1
                })
              }
              let routerPath = AppInfo.isGenericVersion() ? '/login/genericforgotpassword' : '/login/forgotpassword'
              return {path: routerPath, query: {account: this.account, countryCode: this.$route.query.countryCode, isEmail: this.isEmail}}
            }.bind(this)
          },
          'or Sign in': {
            text: 'or',
            router: 'Sign in',
            fn: function () {
              // 埋点统计：重置密码页面点击回到登录页
              if (!AppInfo.isGenericVersion()) {
                uploadWebEvent('RESET_BACK_TO_SIGNIN', {
                  type: this.isEmail ? 0 : 1
                })
              }
              return '/login/signin'
            }.bind(this)
          },
          // 退到登录页面
          'Going back to sign in page': {
            router: 'Going back to sign in page',
            fn: function () {
              return '/login/signin'
            }
          }
        },
        isGenericVersion: AppInfo.isGenericVersion()
      }
    },
    props: ['type', 'isEmail', 'account'],
    mounted () {
      // 注册成功后5s后跳转到登录页
      if (this.type === 'Going back to sign in page') {
        let sec = 5
        this.params[this.type].router = 'Going back to sign in page(' + sec + 's)'
        let time = setInterval(() => {
          sec--
          this.params[this.type].router = 'Going back to sign in page(' + sec + 's)'
          if (sec === 0) {
            clearInterval(time)
            this.$router.push('/login/signin')
          }
        }, 1000)
      }
      console.log(this.params, this.type)
    },
    methods: {
      clickRouter () {
        let res = this.params[this.type].fn()
        this.$router.push(res)
      },
      help () {
        this.$emit('scanHelp')
      }
    }
  }
</script>

<style lang="less" scoped>
	.foot {
    width: 100%;
    height: 14px;
    margin-top: 60px;
    text-align: center;
    span {
      color: #939699;
    }
    a {
      color: #3f86de;
      text-decoration: none;
      cursor: pointer;
    }
    .cursor-help {
      cursor: help;
    }
  }
</style>



// WEBPACK FOOTER //
// Foot.vue?20065e4a